import { SxProps } from '@mui/material';
import { UserAccess } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import { UserOnView } from 'shared/domain/user/types/view';

export enum UserCardVariant {
  standard = 'standard',
  withAccessError = 'withAccessError',
}

export enum AccessErrorType {
  accountDeleted = 'accountDeleted',
  noSiteAccess = 'noSiteAccess',
  noProcessAccess = 'noProcessAccess',
  noPermissionsRole = 'noPermissionsRole',
  noIssueAccess = 'noIssueAccess',
}

export interface AccessErrorInfo {
  type: AccessErrorType;
  entityName?: string;
}

export interface UserCardProps {
  user: UserOnView;
  userAccesses?: UserAccess[];
  issueId: string | null;
  siteId: string | null;
  processId: string | null;
  sx?: SxProps;
  variant?: UserCardVariant;
  accessError?: AccessErrorInfo;
  currentSiteName?: string;
  currentProcessName?: string;
}
